import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

import marketingImage1 from '../assets/images/services/it/CCTV2.jpg';
import marketingImage2 from '../assets/images/services/it/EMS1.jpg';
import marketingImage3 from '../assets/images/services/it/INTRUSTION ALARMS.jpg';
import marketingImage4 from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';

import softwareVideo from '../assets/videos/software/digital-marketing.mp4';

import marketingBenefitsImage from '../assets/images/software/digital-marketing.jpg';

const SoftwareDigitalMarketingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Digital Marketing" description="Digital marketing services in DRC. SEO, social media marketing, content strategy, and online advertising by Cool & Care." keywords="digital marketing DRC, SEO services, social media marketing, online advertising Kinshasa" />
      <ServiceSchema name="Digital Marketing" description="Digital marketing including SEO, social media, content strategy, and online advertising." url="/software-digital-marketing" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'Digital Marketing', url: '/software-digital-marketing' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareDigitalMarketing.name')}
      serviceDescription={t('servicePage.services.softwareDigitalMarketing.description')}
      videoUrl={softwareVideo}
      productImages={[
        marketingImage1,
        marketingImage2,
        marketingImage3,
        marketingImage4
      ]}
      features={t('servicePage.services.softwareDigitalMarketing.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareDigitalMarketing.benefits', { returnObjects: true }) as string[]}
      benefitsImage={marketingBenefitsImage}
    />
    </>
  );
};

export default SoftwareDigitalMarketingPage;

